import { render, staticRenderFns } from "./TomatModalDetail.vue?vue&type=template&id=624a88d9"
import script from "./TomatModalDetail.vue?vue&type=script&lang=js"
export * from "./TomatModalDetail.vue?vue&type=script&lang=js"
import style0 from "./TomatModalDetail.vue?vue&type=style&index=0&id=624a88d9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports